import * as yup from 'yup';

export type TSectionCollapsible = {
  id: string;
  title: string;
  description: string;
};

export type ContentTypeItem = {
  id: number;
  key: string;
  name: string;
  sort_order?: number | null;
  is_active: boolean;
};

export type ContentTypeFormData = {
  key: string;
  name: string;
  sort_order?: number;
  is_active?: boolean;
};

export const schemaKnowledgeBase = yup.object({
  title: yup.string().required('Field Required'),
  description: yup.string().required('Field Required'),
  is_published: yup.boolean().optional(),
  type_id: yup.number().required('Field Required'),
});

export type KnowledgeBaseFormData = yup.InferType<typeof schemaKnowledgeBase>;
